import React, { useState, useEffect, Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { officials,api, association } from "../../../apis/urls";
import axios from "axios";
import Loader from "../../../common-components/loader";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { message } from "antd";

const AssociationList = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');

        setLoader(true);
        setTimeout(() => {
            Listing();
            AssociationList();
            });
    }, []);
    let navigate = useNavigate();
    const { id } = useParams();

    const [loader,setLoader] = useState(false);
    const [result, setResult] = useState([]);
    const [assoList, setAssoList] = useState([]);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [emptyItem, setEmptyItem] = useState(false);
    const [assName, setAssName] = useState('');

    let counts = 0;
    if(result)
    {
        counts = result.length;
    }



    const AssociationList = () => {
        
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: association+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {

            console.log("newwww", res.data);    
            setAssName(res.data.data.name)
            // setLoader(false)
        });
    }


    
    const Listing = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: officials+"/association/"+id+'?page='+0+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            

            if(response.data.message === "Success"){  
                setResult(response.data.data.items);
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)
            }

            setLoader(false)
            console.log(response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const onChangeSearchTitle = e => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);

            findByTitles(searchTitle)
          .then(response => {
            //console.log(response.data.data);
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)

            }
          })
          .catch(e => {
            console.log(e);
          });
    };

    let token = "Bearer "+localStorage.getItem('token');
    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(officials+'/association/'+id+`?search=${name}`);
    };

    const findByTitle = () => {
        findByTitles(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)
            }
            //console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
    };

    const findByTitlesss = option => {
        return instances.get('officials/association/'+id+`?payment_status=${option}`);
    };


    const [statusFil, setStatusFil] = useState('')

    const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        setStatusFil(searchTitle)
        findByTitlesss(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)
            }
          })
          .catch(e => {
            console.log(e);
          });
    };

    const DeleteOfficial = (oid) => {
        let r = window.confirm("Are you sure you want to delete this Position?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: officials+'/association/'+id+'/'+oid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
               Listing();
               navigate("/officials/"+id)
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }

    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     $('html,body').animate({ scrollTop: 0 }, 'fast');

    //  
     const instance = axios.create({
         baseURL:  officials+"/association/"+id+`?search=`+searchTitle+`&payment_status=`+statusFil+'&page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

         setResult(res.data.data.items)
         setCurrentpage(res.data.data.currentPage)
         setTotalPages(res.data.data.totalPages)
         setTotalPages(res.data.data.totalPages)
         setTotalItems(res.data.data.totalItems)
     
    
    
     
         setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
    //  localStorage.removeItem('token')
    //  navigate("/")
     });




     // const newOffset = (event.selected * 10) % items.length;
     // console.log(
     // `User requested page number ${event.selected}, which is offset ${newOffset}`
     // );
     // setItemOffset(newOffset);
 };


    const exportOfficials  = () => { 

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: api+"impex/officials/export/"+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            message.success("Export successfully")
            window.open(api+"impex/download/coaches/"+response.data.fileName, '_blank')
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
}



    const role = localStorage.getItem('userrole');

    let sl =1;
    return(
        <div>
            <aside class="right-side areas" style={{position:'relative'}}>
                <div class="content-area dash-contentss">


                <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <h2 class="page-title"> Official List - {assName}</h2>
                    </div>
                    <div class="page-rightside-action-column">
                    <div class="input-groups mt-3 mb-3 search-grp">
                        <div class="input-group-prepends">
                            <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                                <option value="none" selected disabled hidden>Payment Status</option>
                                <option value=" ">ALL</option>
                                <option >PAID</option>
                                <option>NOTPAID</option>
                            </select> 
                        </div>
                        <input type="text" 
                        class="form-controls search-bar"             
                        value={searchTitle}
                        onChange={onChangeSearchTitle}
                        placeholder="Search" />
                        <button  class="btn btn-search icon-search" onClick={findByTitle}></button>
                        </div>
                         <Link to={"/addofficials/"+id} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Officials</span> </Link>
                    </div>
                </div>

                
                   

                    <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        {
                            role === 'ASSOCIATION_USER' ?null:
                            (
                                <Fragment>
                                    <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                                    <li class="breadcrumb-item"><Link to="/associations">Association</Link></li>
                                    <li class="breadcrumb-item active" aria-current="page">Official List</li>
                                </Fragment>
                            )
                        }
                        
                    </ol>
                    </nav>
                    <div className="page-rightside-action-column mb-3">    
                        <button onClick={exportOfficials} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} className="addbtnitem-link text-anchor">Export Officials</button>
                    </div>

                    {result?
                    (<div class="number-of">
                        Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                    </div>):null}

                    <div class="faculty-list-wrpr list-wrpr">

                        {result?(
                            result?.map((item,index) =>(

                                <div class="list faculty">
                                <div class="row">
                                    <div class="col-md-1">
                                        <div class="update-date">
                                            <span  class="date-wrpr">{(index+1)+currentpage*10}</span>
                                            <span class="desig">Sl.No</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="faculty-user">
                                            <span class="desig">Name</span>
                                            {item.firstname +' '+ item.lastname} 
                                        </div>     
                                    </div>
                                    <div class="col-md-3">
                                        <div class="update-date">
                                            <span class="date-wrpr" style={{cursor: 'pointer'}} onClick={() => window.location = 'mailto:'+item.email}>{item.email}</span>
                                            <span class="date-wrpr">{item.work_phone} </span>
                                            <span class="desig">Phone & Email</span>
                                            
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-2">
                                        <div class="update-date">
                                            <span class="desig">
                                                {item.payment_status === 'PAID'?
                                                    <span style={{color:'#2CA212', fontWeight:'600'}}>PAID</span>:
                                                    <span style={{color:'#0069FF', fontWeight:'600'}}>PENDING</span>
                                                }
                                            </span>
                                            <span class="desig">Payment Status</span>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-2">
                                        <div class="update-date">
                                            <span class="date-wrpr">$ 15</span>
                                            <span class="desig">Payment Amount</span>
                                        </div>
                                    </div>
                                    
                                   
                                    
                                    <div class="col-md-1">
                                        <div class="list-action-wrpr text-right roundicons-text">
                                            <Link  to={"/officialview/"+id+'/'+item.id} data-toggle="tooltip" title="view" ><i class="view icon-eye" style={{backgroundColor:'#eabb73'}}></i><span>View</span></Link>
                                            {/* <Link  to={"/official_edit/"+id+'/'+item.id} data-toggle="tooltip" title="Edit"><i class="edit icon-pencil3"></i><span>Update</span></Link>
                                            <button onClick={()=> { DeleteOfficial(item.id) }} data-toggle="tooltip" style={{background:'#fff'}} title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button> */}
                                        </div>
                                    </div>

                                </div>

                            
                            </div>

                            ))):null
                        }
                  
                
                    </div>
                    { 
                        !result?
                        (<div className="nodata">
                            <h2>Sorry! No Officials Found</h2>
                        </div>):null
                    }

                    {result?
                    (<div class="number-of footer-number">
                        Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                    </div>):null}
                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }





                    {result?
                    <div class="pagination-wrpr">
                        <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                    </div>:null}
                </div>
            </aside>
        </div>

    )
}

export default AssociationList;
